import React, { FC, useLayoutEffect } from 'react';

import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { actions } from 'containers/Visibility/IncidentResponse/slice';

import { ActivityGroupForm } from './ActivityGroupForm';

export const EditActivityGroupForm: FC = () => {
  const dispatch = useDispatch();
  const { group_id } = useParams<{ group_id: string }>();

  useLayoutEffect(() => {
    if (!group_id) return;

    dispatch(actions.getActivityGroup({ q: { activityGroupId: group_id } }));
    dispatch(
      actions.getActivityGroupBuckets({ q: { activityGroupId: group_id } }),
    );
  }, [dispatch, group_id]);

  return <ActivityGroupForm action="Update" />;
};
